var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 8.83333V14.6667C16.5003 15.1269 16.1272 15.5 15.667 15.5H2.33366C1.87343 15.5 1.50033 15.1269 1.50033 14.6667V8.83333H0.666992V7.16667L1.50033 3H16.5003L17.3337 7.16667V8.83333H16.5003ZM3.16699 8.83333V13.8333H14.8337V8.83333H3.16699ZM4.00033 9.66667H10.667V12.1667H4.00033V9.66667ZM1.50033 0.5H16.5003V2.16667H1.50033V0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.034d7c1c287006c74c4184f3531ab27a.svg";
export { ForwardRef as ReactComponent };